import React, { useEffect, useRef, useState } from "react";
import { useSelector, useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom';
import _ from 'lodash'
import { IoMdArrowDropright } from "react-icons/io";
import { Popup } from "semantic-ui-react";
import TreeView from "react-accessible-treeview";
import { aaiflattenTree } from '../utils/aaiTreeViewUtils'
import { setActiveArticle } from '../slices/coreAssetsSlice'
import expandIcon from '../assets/expand-arrows.svg'
import collapseIcon from '../assets/collapse-arrows.svg'

import '../styles/treeView.css'
import cx from "classnames";

// const test_folder = {
//   name: "",
//   children: [
//     {
//       name: "Fruits",
//       children: [
//         { name: "Avocados" },
//         { name: "Bananas" },
//         { name: "Berries" },
//         { name: "Oranges" },
//         { name: "Pears" },
//       ],
//     },
//     {
//       name: "Drinks",
//       children: [
//         { name: "Apple Juice" },
//         { name: "Chocolate" },
//         { name: "Coffee" },
//         {
//           name: "Tea",
//           children: [
//             { name: "Black Tea" },
//             { name: "Green Tea" },
//             { name: "Red Tea" },
//             { name: "Matcha" },
//           ],
//         },
//       ],
//     },
//     {
//       name: "Vegetables",
//       children: [
//         { name: "Beets" },
//         { name: "Carrots" },
//         { name: "Celery" },
//         { name: "Lettuce" },
//         { name: "Onions" },
//       ],
//     },
//   ],
// };

let flatData = aaiflattenTree({ name: "", children: [], uuid: '' });

function ArticleArchiveTree() {
  const dispatch = useDispatch()
  const navigate = useNavigate();
  const [expandedIds, setExpandedIds] = useState();
  let optionsList = useRef([])
  let allBranchIds = useRef([])

  const artItemsList = useSelector((state) => {
    // console.log('ArticleSidebar articleList', state.core.articles.articles);
    if (state.core.articles.articles) {
      optionsList.current = state.core.articles.articles.map((x) => {
        let key_value = x.name.replace(/[^a-z0-9]/gi, '').toLowerCase()
        return { key: key_value, text: x.name, value: key_value, data: x }
      })
      // console.log('allArticles', articleListOptions);

    }
    return state.core.articles.articles;
  })

  useEffect(() => {
    if (!_.isEmpty(optionsList.current) && optionsList.current.length > 0) {
      let info = _.map(optionsList.current, x => {
        let newData = { name: x.data.name, category: x.data.categories[0].toUpperCase(), updatedOn: Date.parse(x.data.updatedOn), uuid: x.data.uuid }
        return newData;
      })

      info = _.sortBy(Object.values(info), ['category', 'name', 'updatedOn'])

      const treeView = {
        name: '',
        children: info.reduce((acc, cur) => {
          // find an existing category
          const existingCategory = acc.find(cat => cat.name === cur.category);
          if (existingCategory) {
            // if category exists, push the new name into the children array
            existingCategory.children.push({ name: cur.name, uuid: cur.uuid });
          } else {
            // if category doesn't exist, create a new one
            acc.push({
              name: cur.category,
              children: [{ name: cur.name, uuid: cur.uuid }]
            });
          }
          return acc;
        }, [])
      }
      let convertedList = treeView
      let testflatData = aaiflattenTree(convertedList);

      // get all nodes for expand all feature
      allBranchIds.current = testflatData
        .filter(node => node.children && node.children.length > 0)
        .map(node => node.id);

      flatData = testflatData;
      setExpandedIds(allBranchIds.current);
    }
  }, [artItemsList])

  // const onKeyDown = (e) => {
  //   if (e.key === "Enter") {
  //     getAndSetIds();
  //   }
  // };

  // const getAndSetIds = () => {
  //   setExpandedIds(
  //     document
  //       .querySelector("#txtIdsToExpand")
  //       .value.split(",")
  //       .filter(val => !!val.trim())
  //       .map((x) => {
  //         if (isNaN(parseInt(x.trim()))) {
  //           return x;
  //         }
  //         return parseInt(x.trim());
  //       })
  //   );
  // };
  const expandAll = () => {
    setExpandedIds(allBranchIds.current);
  };
  const goToArticle = (uuid) => {
    dispatch(setActiveArticle(uuid));
    navigate(`/articleItemContainer/${uuid}`);
    dispatch(setActiveArticle(uuid));
    // return <ArticleItem uuid={uuid} />
    return null;
  }
  return (
    <div style={{ paddingLeft: "10px", paddingRight: "10px" }}>
      {/* <div>
        <label htmlFor="txtIdsToExpand">
          Comma-delimited list of branch node IDs to expand:
        </label>
        <input id="txtIdsToExpand" type="text" onKeyDown={onKeyDown} />
        <button onClick={() => getAndSetIds()}>Set</button>
      </div> */}
      <div >

        <Popup
          offset={[-4]}
          content={"Click to close all archive groups"}
          key={"closecharPopup"}
          header={"Close Archive"}
          trigger={
            <div className={(expandedIds && expandedIds.length < 1) ? "hideButton floatRight" : "showButton floatRight"} onClick={() => setExpandedIds([])} >
              <img className='hint-img' src={collapseIcon} alt="Collapse" width={30} />
            </div>

          }
        />

        <Popup
          offset={[-4]}
          content={"Click to expand all archive groups"}
          key={"expandcharPopup"}
          header={"Expand Archive"}
          trigger={
            <div className={(expandedIds && expandedIds.length > 0) ? "hideButton floatRight" : "showButton floatRight"} onClick={() => expandAll()} >
              <img className='hint-img' src={expandIcon} alt="Collapse" width={30} />
            </div>

          }
        />
      </div>
      <div className="checkbox article-tree-view-container">
        {/* ⚠️ Mount TreeView only once there are nodes to show.
            `flatData` is built at MODULE LOAD from an empty root and only filled in the effect
            above, so the first paint handed the library a root with no children and it logged
            "TreeView have no nodes to display" — twice per visit, on a page that was working.
            A flattened empty root is length 1 (the root itself), so >1 means real content. */}
        {flatData.length > 1 && <TreeView
          data={flatData}
          aria-label="Controlled expanded node tree"
          expandedIds={expandedIds}
          defaultExpandedIds={[1]}
          nodeRenderer={({
            element,
            isBranch,
            isExpanded,
            isDisabled,
            getNodeProps,
            level,
            handleExpand,
          }) => {
            const handleClick = (e) => {
              // If node has children, expand/collapse it
              if (isBranch) {
                handleExpand(e);
              } else {
                // If node is a leaf (no children), call your handler with uuid
                console.log('handleClick', element)
                goToArticle(element.uuid);
              }
            };
            return (
              <div
                {...getNodeProps({ onClick: handleClick })}
                style={{
                  marginLeft: 40 * (level - 1),
                  opacity: isDisabled ? 0.5 : 1,
                  display: 'flex',     // Add this line
                  alignItems: 'center', // And this line
                  cursor: 'pointer'
                }}
              >
                {isBranch && <ArrowIcon isOpen={isExpanded} />}
                <span className="name">
                  {element.name}
                </span>
              </div>
            );
          }}
        />}
      </div>
    </div>
  );
}

const ArrowIcon = ({ isOpen, className }) => {
  const baseClass = "arrow";
  const classes = cx(
    baseClass,
    { [`${baseClass}--closed`]: !isOpen },
    { [`${baseClass}--open`]: isOpen },
    className
  );
  return <IoMdArrowDropright className={classes} size={20} />;
};

export default ArticleArchiveTree;